<template>
    <tr @click="recordSelected">
        <td>{{ index + 1 }}</td>

        <td style="padding: 0 16px" v-if="lessonSelected.formLevel >= 4">{{  markRecord.class_id }}</td>

        <td class="pt-1">
            {{ markRecord.name }}
        </td>

        <td v-if="termMarkOnly">
            <v-text-field
                v-model="markRecord.exam_mark"
                outlined
                dense
                hide-details
                @blur="recordChanged"
                
            ></v-text-field>
        </td>

        <td v-else>
            <v-text-field
                v-model="markRecord.course_mark"
                outlined
                dense
                :filled="disableCourseMark"
                :disabled="disableCourseMark"
                hide-details
                @blur="recordChanged"
                
            ></v-text-field>
        </td>

        <td v-if="termMarkOnly">
            <v-text-field
                v-model="markRecord.course_mark"
                outlined
                dense
                hide-details
                @blur="recordChanged"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>

        <td v-else>
            <v-text-field
                v-model="markRecord.exam_mark"
                outlined
                dense
                hide-details
                @blur="recordChanged"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>

        <td>
             <v-text-field
                v-model="total"
                outlined
                dense
                hide-details                
                filled
                disabled
            ></v-text-field>
        </td>

        <td>
           <v-select
                v-model="codedComment"                
                :items="comments1"
                item-value="id"
                outlined
                dense
                hide-details
                return-object                
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.id }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.comment }}
                </template> 

            </v-select>
        </td>

        <td>
            <v-select
                v-model="codedComment1"                
                :items="comments2"
                item-value="id"
                outlined
                dense
                hide-details
                return-object                
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.id }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.comment }}
                </template> 

            </v-select>
        </td>

        <td>
            <v-tooltip 
                bottom
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="primary"                        
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveStatus.saved"
                        class="mr-2"
                    >
                        mdi-check-all
                    </v-icon>
                </template>    
                <span>Saved</span>                
            </v-tooltip>
            <v-tooltip 
                top
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="red"                       
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveStatus.error"
                    >
                        mdi-alert-circle
                    </v-icon>
                </template>    
                <span>Error</span>               
            </v-tooltip>
            <v-progress-circular
                indeterminate
                color="primary"
                v-show="saveStatus.saving"
                size="16"
                width="3"
            ></v-progress-circular>
        </td>
    </tr>

    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props:{
        studentRecord: Object, 
        index: Number       
    },
    created () {
        this.initialize();
    }, 

    watch: {        
        codedComments: {
            deep: true,
            handler(value){
                if(value.length != 0){
                    this.setComments();
                }
            }
        }
    },       
    data() {
        return {
            commentsConduct: [],
            commentsApplication: [],
            commentsPreparedness: [],            
            comments1: [],
            comments2: [],            
            markRecord: {},
            codedComment: { id: null, comment: null },
            codedComment1: { id: null, comment: null },
            conduct: { id: null, comment: null },
            application: { id: null, comment: null },
            preparedness: { id: null, comment: null },            
            comments3: [
                { id: null, comment: null},
                { id: 1, comment: 'Excellent' },
                { id: 2, comment: 'Good' },
                { id: 3, comment: 'Satisfactory' },
                { id: 4, comment: 'More Effort Required' },
                { id: 5, comment: 'Cause for Concern' },
            ],
            selectColumns:[
                { text: 'Conduct', model: 'conduct' }
            ],
            saved: false,
            saving: false,
            error: false,
            disableConduct: false,
            disableApplication: false,
            disablePreparedness: false,
            disableCodedComment: false,
            disableCodedComment1: false,
            disableExamMark: false,
            disableCourseMark: false,
            termMarkOnly: false,  
            saveStatus: {
                saved: false,
                saving: false,
                error: false
            },          
        }
    },
    computed: {
        ...mapGetters({
            codedComments: 'termReports/getCodedComments',
            employeeId: 'auth/getEmployeeId',
            primaryColor: 'termReports/getPrimaryColor',
            colorDarken: 'termReports/getColorDarken',
            marksEntered: 'termReports/getSubjectStudentsMarksEntered',
            lessonSelected: 'termReports/getLessonSelected',
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm', 
        }),
       
        total(){
            const formLevel = this.lessonSelected.formLevel;

            if(this.markRecord.year >= 2025 & ((this.currentTerm == 3 && formLevel == 4) || (formLevel >= 5))){
                return (this.markRecord.course_mark * 0.2 + this.markRecord.exam_mark * 0.8).toFixed(1);
            }
            
            if(this.markRecord.year >= 2025){
                return (this.markRecord.course_mark * 0.5 + this.markRecord.exam_mark * 0.5).toFixed(1);
            }

            if(formLevel == 5) return 'NA';

            else if(this.currentTerm == 2){
                if(formLevel == 6) return 'NA'
            }
            else if(this.currentTerm == 3){
                if(formLevel == 3 || formLevel == 4) return 'NA'
            }
            return (this.markRecord.course_mark * 0.6 + this.markRecord.exam_mark * 0.4).toFixed(1);
        }        
    },
    methods : {
        ...mapMutations({
            setUpdatedRecord: 'termReports/setUpdatedTable2Record',
            setStudentSelected: 'termReports/setMarkSheetStudentSelected',
            setMarkSheetEntered: 'termReports/setSubjectStudentsMarksEntered',
        }),
        ...mapActions({
            save: 'termReports/saveTable2Record',
            getStudents: 'termReports/getStudents',
        }),
        
        initialize(){
            //this.markRecord = {...this.studentRecord};
            this.markRecord = JSON.parse(JSON.stringify(this.studentRecord));
            this.savedDataCheck();
            this.setComments();
            this.setDisabledFields();
        },
        async recordChanged(){
            //console.log(this.recordBlankCheck());
            if(this.recordBlankCheck()) return;
                this.setSaveStatus();
                this.setUpdatedRecord(
                    {
                        "student_id" : this.markRecord.student_id,
                        "year" : this.markRecord.year,
                        "term" : this.markRecord.term,
                        "subject_id" : this.markRecord.subject_id,
                        "exam_mark" : this.markRecord.exam_mark,
                        "course_mark" : this.markRecord.course_mark,
                        "conduct" : this.conduct.id,
                        "application" : this.application.id,
                        "preparedness" : this.preparedness.id,
                        "coded_comment" : this.codedComment.id,
                        "coded_comment_1" : this.codedComment1.id,
                        "employee_id" : this.employeeId,                   
                    }
                );
                
                try {
                    await this.save();
                    //await this.getStudents(this.employeeId);
                    this.setSaveStatus('saved');
                } catch (error) {
                    error.response ? console.log(error.response) : console.log(error);
                    this.$emit('error', error?.response ?? null);
                    this.setSaveStatus('error');
                }
                          
        },
        recordBlankCheck(){
            let record = [];
            let blank = true;
            record.push(this.markRecord.course_mark);
            record.push(this.markRecord.exam_mark);
            record.push(this.markRecord.conduct);
            record.push(this.markRecord.application);
            record.push(this.markRecord.preparedness);
            record.push(this.markRecord.coded_comment);
            record.push(this.markRecord.coded_comment_1);

            record.forEach(element => {
                if(element) blank = false;
            })

            return blank;
        },
        savedDataCheck(){
            if(!this.recordBlankCheck()) this.saved = true;
        },
        recordSelected(){
            // let records = this.table2Records;
            //console.log(records);
            // let entered = 0;
            // records.forEach(record => {
            //     if(record.course_mark || record.exam_mark || record.conduct || record.application || record.preparedness || record.coded_comment || record.coded_comment_1){
            //         entered++;
            //     }
            // })
            this.setStudentSelected(this.markRecord.name);
        },        
        setComments(){ 
            this.comments1.push({id: null, comment: null});  
            this.comments2.push({id: null, comment: null});
            //console.log(this.codedComments);  
            this.codedComments.forEach(record =>{
                this.comments1.push({ id: parseInt(record.id), comment: record.detail });
                this.comments2.push({ id: parseInt(record.id), comment: record.detail });
            });
            this.commentsConduct = [...this.comments3];
            this.commentsApplication = [...this.comments3];
            this.commentsPreparedness = [...this.comments3];
            if(this.studentRecord.conduct){
                this.conduct = { id: parseInt(this.studentRecord.conduct) }
                //console.log(this.conduct);
            } 
            if(this.studentRecord.application){
                this.application = { id: parseInt(this.studentRecord.application) }
            } 
            if(this.studentRecord.preparedness){
                this.preparedness = { id: parseInt(this.studentRecord.preparedness) }
            } 
            if(this.studentRecord.coded_comment){
                this.codedComment = { id: parseInt(this.studentRecord.coded_comment) };
            } 
            if(this.studentRecord.coded_comment_1){
                this.codedComment1 = { id: parseInt(this.studentRecord.coded_comment_1) };
            }
            
        },
        setDisabledFields(){
            if(this.markRecord.year >= 2025) return;

            const  formLevel = this.lessonSelected.formLevel;

            if(formLevel == 5){
                this.disableCourseMark = true
            }
            
            if(this.currentTerm == 2 && formLevel == 6){
                this.disableCourseMark = true;
            }

            if(this.currentTerm == 3 && (formLevel == 3 || formLevel == 4)){
                this.disableCourseMark = true;
            } 
        },
       

        setSaveStatus (status = 'saving') {
           Object.keys(this.saveStatus).forEach(key => {
               this.saveStatus[key] = false;
               if(key == status) this.saveStatus[key] = true
           })
        },
    }
}
</script>